import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { sprintf } from 'sprintf-js';

import { environment } from '../../environments/environment';
import { BaseService } from './base.service';

@Injectable()
export class CoreEventPaymentService extends BaseService {

  constructor(
    protected http: HttpClient,
  ) {
    super(http, `${environment.apiBaseUrl}/companies/%(company_id)s/core_events/%(event_id)s/payments`);
  }

  feeForServiceAttendees(urlParams: any = {}, apiParams: any = {}): Observable<any> {
    const url = sprintf(`${environment.apiBaseUrl}/companies/%(company_id)s/core_events/%(event_id)s/fee_for_service_attendees`, urlParams);
    return this.http.get<any[]>(url, { params: this.toHttpParams(apiParams) });
  }
}
